import { CustomConditionModel, SpecialConditionData, SpecialConditionDataConditionType } from '@urbanx/agx.campaigns.client';

export const updateModelOnCustomCondition = (
  model: CustomConditionModel,
  customCondition: SpecialConditionData
): SpecialConditionData => {
  if (!model ||
    customCondition.conditionType !== SpecialConditionDataConditionType.Custom)
    return customCondition;

  const clause = customCondition.clauses?.[0];
  const dataPoint = clause?.dataPoints?.[0];

  const updatedSpecialCondition: SpecialConditionData = {
    ...customCondition,
    clauses: [
      {
        ...clause,
        dataPoints: [
          {
            ...dataPoint,
            model: {
              custom: model,
            },
          },
        ],
      },
    ],
  };

  return updatedSpecialCondition;
};
